import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DetailsBlock from '../components/tables/DetailsBlock';
import { DetailsValueBlock } from '../components/tables/DetailsValueBlock';
import { localizations } from '../localization/localization';
import DetailsContainer from '../components/tables/DetailsContainer';
import { FilterSettingsModel, FilterTarget, LocationNameModel } from '../common/models/CommonModels';
import { UnitModel, UnitProperties, UnitType } from '../units/UnitModels';
import { renderEmailDetails, renderPersonDetails, renderPhoneDetails, renderCompanyDetails, renderWebsiteDetails } from '../components/tables/DetailsHelpers';
import { EditItemProps, DeleteItemProps, CopyItemProps, MessagingProps } from '../common/props/itemProps';
import { toCommaDecimal } from '../utils/numberUtils';
import * as UnitStore from './store/FilterSettingsStore';
import { ApplicationState } from "../store";
import { connect } from 'react-redux';
import ZeckitSmallWidget from '../common/ZeckitSmallWidget';
import { SettingsProperties } from './models/SettingsModels';

interface FilterSettingsDetailsProps extends FilterSettingsModel, EditItemProps<FilterSettingsModel>, DeleteItemProps<FilterSettingsModel>, CopyItemProps<FilterSettingsModel> {
    onShowFilterOnMap: (filter: FilterSettingsModel) => void;
    departureCities: LocationNameModel[];
    destinationCities: LocationNameModel[];
}

const renderProperties = (properties: SettingsProperties) => {
    return <Grid container direction="column">
        {properties !== null && properties !== undefined && properties.adr ? <Grid item><Typography>{localizations.trucks.properties.adr}</Typography></Grid> : null}
        {properties !== null && properties !== undefined && properties.thermal ? <Grid item><Typography>{localizations.trucks.properties.thermal}</Typography></Grid> : null}
        {properties !== null && properties !== undefined && properties.glass ? <Grid item><Typography>{localizations.trucks.properties.glass}</Typography></Grid> : null}
        {properties !== null && properties !== undefined && properties.tank ? <Grid item><Typography>{localizations.trucks.properties.tank}</Typography></Grid> : null}
        {properties !== null && properties !== undefined && properties.mega ? <Grid item><Typography>{localizations.trucks.properties.mega}</Typography></Grid> : null}
        {properties !== null && properties !== undefined && properties.explosive ? <Grid item><Typography>{localizations.trucks.properties.explosive}</Typography></Grid> : null}
        {properties !== null && properties !== undefined && properties.pieceGoods ? <Grid item><Typography>{localizations.trucks.properties.pieceGoods}</Typography></Grid> : null}
        {properties !== null && properties !== undefined && properties.bulkGoods ? <Grid item><Typography>{localizations.trucks.properties.bulkGoods}</Typography></Grid> : null}
    </Grid>
}

function pad(num: number) {
  return ("0"+num).slice(-2);
}
function hhmmss(secs: number) {
  let minutes = Math.floor(secs / 60);
  secs = secs%60;
  const hours = Math.floor(minutes/60);
  minutes = minutes%60;
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}
function hmin(secs: number) {
  let minutes = Math.floor(secs / 60);
  secs = secs%60;
  const hours = Math.floor(minutes/60);
  minutes = minutes%60;
  return `${hours}${localizations.common.h} ${pad(minutes)}${localizations.common.min}`;
}

const renderTimeEstimate = (props: any) => {

    const units = props.units.routes
    let length = 0
    let secs = 0
    let formattedTime = ''
    Object.keys(units).forEach((value, index) => {
      if (props.destinationCity !== null && units[value].from.id === props.departureCity.id &&  units[value].to.id === props.destinationCity.id && units[value].distance !== null) {
          length = Math.round(units[value].distance)
          secs = Math.ceil(length / 80 * 3600)
          formattedTime = hmin(secs)
        }
    });
    if (formattedTime !== '') {
        return <span>~ {formattedTime} {localizations.common.speedUsedForCalc}</span>
    }
    else {
        return null
    }
  }


const FilterSettingsDetails: React.SFC<FilterSettingsDetailsProps> = (props) => {

    
    const getCities = (selectedIds: string[], cities: LocationNameModel[]) => {
        const cityNames: string[] = [];
        selectedIds.map((selId) => {
            const city = cities.find((item) => item.id === selId)
            if (city){
                cityNames.push(city.name);
            } else {
                cityNames.push(selId);
            }
        });
        return cityNames;
    }

    const renderFromCitySelectValue = (selected: any[]) => {
        const selectedCount = selected.length;
        if (selectedCount > 5){
            return `${selectedCount} ${localizations.actions.selected.toLowerCase()}`;
        }
        else {
            return getCities(selected, props.departureCities).join(', ');
        }
    }

    const renderToCitySelectValue = (selected: string[]) => {
        const selectedCount = selected.length;
        if (selectedCount > 5){
            return `${selectedCount} ${localizations.actions.selected.toLowerCase()}`;
        }
        else {
            return getCities(selected, props.destinationCities).join(', ');
        }
    }

    const Buttons = () => (
        <Grid container spacing={2}>
            {props.isEditEnabled && props.isEditEnabled(props) ? <Grid item><Button variant="outlined" color="primary" onClick={() => props.onEdit && props.onEdit(props)}>{localizations.actions.edit}</Button></Grid> : null}
            {props.isDeleteEnabled && props.isDeleteEnabled(props) ? <Grid item><Button variant="outlined" color="primary" onClick={() => props.onDelete && props.onDelete(props)}>{localizations.actions.delete}</Button></Grid> : null}
            {props.isCopyEnabled && props.isCopyEnabled(props) ? <Grid item><Button variant="outlined" color="primary" onClick={() => props.onCopy(props)}>{localizations.actions.copy}</Button></Grid> : null}
            <Grid item>
                <Button variant="outlined" color="primary" onClick={(e) => props.onShowFilterOnMap(props)}>{localizations.actions.showOnMap}</Button>
            </Grid> 
            {/* onGoToMap */}
        </Grid>
    );

    return (
        <DetailsContainer>
            <DetailsBlock
                title={localizations.filterSettings.filterSettingsDetailsHeader}
                rightItems={<Buttons />}>
                {props.name && props.name.length > 0 ?
                    <DetailsValueBlock title={localizations.common.name}>
                        <Typography>{props.name}</Typography>
                    </DetailsValueBlock>
                    : null}
                    {/* {props.tracking ?
                        <DetailsValueBlock title={localizations.common.tracking}>
                            <Typography>{localizations.common.tracking}</Typography>
                        </DetailsValueBlock>
                        : 
                        <DetailsValueBlock title={localizations.common.tracking}>
                            <Typography>{localizations.common.notTracking}</Typography>
                        </DetailsValueBlock>}
                    {props.targetType ?
                        <DetailsValueBlock title={localizations.filterSettings.target}>
                            <Typography>{localizations.filterTargetType[props.targetType]}</Typography>
                        </DetailsValueBlock>
                        : null} */}
                <DetailsValueBlock title={localizations.common.generalSearchField}>
                    {props.generalSearchField}
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.common.properties}>
                    {renderProperties(props.properties)}
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.common.pointOfDeparture}>
                    {renderFromCitySelectValue(props.departureCityIds)}
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.common.pointOfArrival}>
                    {renderToCitySelectValue(props.destinationCityIds)}
                </DetailsValueBlock>
            </DetailsBlock>
        </DetailsContainer>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    const { filterSettings } = state;
    return { filterSettings };
}

export default connect<any, any, any>(mapStateToProps)(FilterSettingsDetails);


// WEBPACK FOOTER //
// ./src/account/FilterSettingsDetails.tsx